import React from 'react';

import styles from './Header.module.scss';

interface Props {
  title: string;
  subtitle: string;
  year?: number;
  miles?: string[];
  engineType?: string;
  gearbox?: string;
  customCarTitle?: string;
}

export const Header: React.FC<Props> = ({
  title,
  subtitle,
  year,
  miles,
  engineType,
  gearbox,
  customCarTitle,
}) => (
  <div className={styles.wrapper}>
    <h1>{customCarTitle || title}</h1>
    <h2>{subtitle}</h2>
    {(year || miles || engineType || gearbox) && (
      <div className={styles.meta}>
        {year && <span>{year}</span>}
        {miles && <span>{miles} mil</span>}
        {engineType && <span>{engineType}</span>}
        {gearbox && <span>{gearbox}</span>}
      </div>
    )}
  </div>
);
